<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <template>
          <el-alert
            title="推荐奖计算：比较“推荐人”与“被推荐人”两人中较低的等级所配置的奖励金额来进行分配，奖励给“推荐人”、“推荐人上级”两代。"
            type="warning"
            :closable="false"
          />
        </template>

        <el-form-item label="等级名称" required prop="level_name">
          <el-input v-model="form.level_name" />
        </el-form-item>

        <el-form-item label="上代推荐奖励" prop="invite_rebate1">
          <el-input placeholder="请输入内容" v-model="form.invite_rebate1">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="上上代推荐奖励" prop="invite_rebate2">
          <el-input placeholder="请输入内容" v-model="form.invite_rebate2">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="报单金额" prop="bill_amount">
          <el-input placeholder="请输入内容" v-model="form.bill_amount">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="报单商品起购" prop="min_buy_num">
          <el-input placeholder="请输入内容" v-model="form.min_buy_num">
            <template slot="append">件</template>
          </el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import { editUserLevel, updateUserLevel, createUserLevel } from '@/api/user-levels'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        level_name: '',
        invite_rebate1: 0,
        invite_rebate2: 0,
        bill_amount: 0,
        min_buy_num: 0,
        remark: '',
      },
      errors: {},
    }
  },
  methods: {
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editUserLevel(this.resourceId))
        this.fillForm(data)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateUserLevel(this.resourceId, this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
